import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLanguage } from '../contexts/LanguageContext'

const AboutSection = ({ onOpenChat }) => {
  const { t } = useTranslation()
  const { isRTL: _isRTL } = useLanguage()
  
  return (
    <section style={{
      padding: 'clamp(40px, 8vw, 80px) 0',
      backgroundColor: '#f8f9fa',
      position: 'relative',
      zIndex: 15
    }}>
      <div style={{
        maxWidth: 'clamp(320px, 90vw, 1200px)',
        margin: '0 auto',
        padding: '0 clamp(15px, 4vw, 20px)'
      }}>
        {/* Main Content */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: 'clamp(40px, 8vw, 80px)',
          alignItems: 'center',
          marginBottom: 'clamp(40px, 8vw, 80px)'
        }}>
          {/* Left Side - Text Content */}
          <div>
            <h2 style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: 'clamp(32px, 5vw, 48px)',
              fontWeight: 400,
              lineHeight: 1.2,
              color: '#1a1a1a',
              marginBottom: '24px',
              letterSpacing: '-0.02em'
            }}>
              {t('about.title')}
            </h2>
            
            <h3 style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: 'clamp(20px, 3vw, 28px)',
              fontWeight: 500,
              lineHeight: 1.3,
              color: '#1a1a1a',
              marginBottom: '20px',
              letterSpacing: '-0.01em'
            }}>
              {t('about.subtitle')}
            </h3>
            
            <p style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '16px',
              lineHeight: 1.6,
              color: '#4a4a4a',
              marginBottom: '20px'
            }}>
              {t('about.description')}
            </p>
            
            <p style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '16px',
              lineHeight: 1.6,
              color: '#4a4a4a',
              marginBottom: '40px'
            }}>
              {t('about.additionalInfo')}
            </p>
            
            <div style={{
              marginBottom: '30px'
            }}>
              <p style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '16px',
                fontWeight: 600,
                color: '#1a1a1a',
                marginBottom: '10px'
              }}>
                {t('about.contactInfo')}
              </p>
              <p style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '14px',
                color: '#4a4a4a',
                marginBottom: '5px'
              }}>
                {t('about.email')}: info@almikial.com.sa
              </p>
              <p style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '14px',
                color: '#4a4a4a',
                marginBottom: '0px'
              }}>
                {t('about.phone')}: +966 11 222 3311
              </p>
            </div>
            
            <button 
              onClick={() => onOpenChat && onOpenChat()}
              style={{
                height: '50px',
                border: '2px solid #1a1a1a',
                borderRadius: '0px',
                background: 'transparent',
                padding: '0 24px 0 24px',
                fontFamily: 'Inter, sans-serif',
                fontSize: '14px',
                fontWeight: 500,
                letterSpacing: '0.05em',
                textTransform: 'uppercase',
                color: '#1a1a1a',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                outline: 'none',
                minWidth: '180px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#1a1a1a'
                e.target.style.color = '#ffffff'
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent'
                e.target.style.color = '#1a1a1a'
              }}>
                {t('about.contactButton')}
              </button>
          </div>
          
          {/* Right Side - Statistics */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
            gap: 'clamp(20px, 4vw, 40px)'
          }}>
            {/* Years Experience */}
            <div style={{
              textAlign: 'center',
              padding: '30px 20px',
              backgroundColor: '#ffffff',
              borderRadius: '8px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
            }}>
              <div style={{
                fontSize: '48px',
                fontWeight: 700,
                color: '#1a1a1a',
                marginBottom: '8px',
                fontFamily: 'Inter, sans-serif'
              }}>
                20+
              </div>
              <div style={{
                fontSize: '16px',
                color: '#666666',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500
              }}>
                {t('about.stats.experience')}
              </div>
            </div>
            
            {/* Practice Areas */}
            <div style={{
              textAlign: 'center',
              padding: '30px 20px',
              backgroundColor: '#ffffff',
              borderRadius: '8px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
            }}>
              <div style={{
                fontSize: '48px',
                fontWeight: 700,
                color: '#1a1a1a',
                marginBottom: '8px',
                fontFamily: 'Inter, sans-serif'
              }}>
                4
              </div>
              <div style={{
                fontSize: '16px',
                color: '#666666',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500
              }}>
                {t('about.stats.practiceAreas')}
              </div>
            </div>
            
            {/* Client Focus */}
            <div style={{
              textAlign: 'center',
              padding: '30px 20px',
              backgroundColor: '#ffffff',
              borderRadius: '8px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
            }}>
              <div style={{
                fontSize: '48px',
                fontWeight: 700,
                color: '#1a1a1a',
                marginBottom: '8px',
                fontFamily: 'Inter, sans-serif'
              }}>
                100%
              </div>
              <div style={{
                fontSize: '16px',
                color: '#666666',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500
              }}>
                {t('about.stats.clientFocused')}
              </div>
            </div>
            
            {/* Innovation */}
            <div style={{
              textAlign: 'center',
              padding: '30px 20px',
              backgroundColor: '#ffffff',
              borderRadius: '8px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
            }}>
              <div style={{
                fontSize: '48px',
                fontWeight: 700,
                color: '#1a1a1a',
                marginBottom: '8px',
                fontFamily: 'Inter, sans-serif'
              }}>
                24/7
              </div>
              <div style={{
                fontSize: '16px',
                color: '#666666',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500
              }}>
                {t('about.stats.support')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutSection